module.exports = __webpack_public_path__ + "officialStatic/img/new17.e0c4669.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/news/new17.jpg
// module id = PNCF
// module chunks = 0